import { IconProps } from '@models/icons';

function CsIcon({ size = 24, color = 'white', ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path d="M13 23C12.4477 23 12 22.5523 12 22C12 21.4477 12.4477 21 13 21H19V20H17C15.8954 20 15 19.1046 15 18V14C15 12.8954 15.8954 12 17 12H19V11C19 9.06667 18.3167 7.41667 16.95 6.05C15.5833 4.68333 13.9333 4 12 4C10.0667 4 8.41667 4.68333 7.05 6.05C5.68333 7.41667 5 9.06667 5 11V12H7C8.10457 12 9 12.8954 9 14V18C9 19.1046 8.10457 20 7 20H5C4.45 20 3.97917 19.8042 3.5875 19.4125C3.19583 19.0208 3 18.55 3 18V11C3 9.76667 3.2375 8.60417 3.7125 7.5125C4.1875 6.42083 4.83333 5.46667 5.65 4.65C6.46667 3.83333 7.42083 3.1875 8.5125 2.7125C9.60417 2.2375 10.7667 2 12 2C13.2333 2 14.3958 2.2375 15.4875 2.7125C16.5792 3.1875 17.5333 3.83333 18.35 4.65C19.1667 5.46667 19.8125 6.42083 20.2875 7.5125C20.7625 8.60417 21 9.76667 21 11V21C21 21.55 20.8042 22.0208 20.4125 22.4125C20.0208 22.8042 19.55 23 19 23H13ZM5 18H7V14H5V18ZM17 18H19V14H17V18Z"
                  fill={color}/>
        </svg>
  );
}

export default CsIcon;
